import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';

import LinkBox from '../components/link-box';
import { getOtherAppearances } from '../utils/get-other-appearances';

const LatestEpisode = () => {
  const data = useStaticQuery(graphql`
    query {
      allEpisodesJson {
        edges {
          node {
            id
            guest
            intro
            videoId
            publishedAt(formatString: "ddd, MMM D, YYYY")
            duration
            categories
            booksMentioned {
              amazon
              author
              goodreads
              published
              title
              wikipedia
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `);

  const {
    id,
    guest,
    duration,
    categories,
    publishedAt,
    intro,
    videoId,
    booksMentioned,
    fields: { slug },
  } = data.allEpisodesJson.edges[0].node;
  const otherAppearances = getOtherAppearances(
    id,
    guest,
    data.allEpisodesJson.edges
  );

  return (
    <div>
      <h3 className="mt-10 mb-5">Latest episode</h3>
      <div className="flex flex-col lg:flex-row gap-2 md:gap-10 mb-5">
        <img
          src={`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`}
          alt={`${id} - ${guest}`}
          width="600"
          className="block rounded-lg"
        />
        <div className="md:w-3/5">
          <small className="text-gray-400">{publishedAt}</small>
          <p className="md:text-xl mb-5">{intro}</p>
          <div className="flex flex-wrap gap-2">
            <LinkBox href={`/episodes/${slug}`}>Watch {duration}</LinkBox>
            {booksMentioned && (
              <LinkBox
                href={`/episodes/${slug}`}
                state={{ showBooks: true, hideVideo: true }}
              >
                Books mentioned
              </LinkBox>
            )}
          </div>
          <div className="mt-5 pt-1 flex flex-wrap gap-2 items-center">
            {categories.map((category, idx) => (
              <LinkBox
                key={idx}
                href={`/categories/${category.replace(/^\w+_/, '')}`}
                variant="small"
              >
                #{category.replace(/^\w+_/, '')}
              </LinkBox>
            ))}
          </div>
          <div className="mt-6">
            {otherAppearances.length > 0 && (
              <div className="mt-1 md:mt-2 mb-3 text-gray-400 text-lg">
                Previous appearances:{' '}
                {otherAppearances.map((edge) => (
                  <div
                    className="inline mr-2 border-b border-gray-500"
                    key={`prev-${edge.node.id}`}
                  >
                    <Link to={`/episodes/${edge.node.fields.slug}`}>
                      {edge.node.id}
                    </Link>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestEpisode;
